import React, {PropsWithChildren} from 'react';
import Button from '../../../../incase-domain/components/button/Button';

interface UserInteractionCardProps {
    title: string;
    icon: string;
    content: string | number;
}

function UserInteractionCard(props: PropsWithChildren<UserInteractionCardProps>): JSX.Element {
    const {title, icon = 'solar:stop-linear', content} = props;

    return (
        <div className="c-userInteractionCard">
            <Button className="c-userInteractionCard__icon" leading={icon} color="info" square size="lg" />
            <div className="c-userInteractionCard__body">
                <div className="c-userInteractionCard__title">{title}</div>
                <div className="c-userInteractionCard__content">{content}</div>
            </div>
        </div>
    );
}

export default UserInteractionCard;
